<template>
  <div>
    <section class="columns">
      <div class="column">
        <b-input
          v-model="filter.email"
          placeholder="Email"
          size="is-small"
          rounded
          @input="onFilter"
        />
      </div>
      <div class="column">
        <b-autocomplete
          :data="autocompleteData"
          :loading="autocompleteLoading"
          :clearable="true"
          field="programName"
          placeholder="Program"
          size="is-small"
          rounded
          @typing="onTyping"
          @select="item => onselect(item)"
        />
      </div>
      <div class="column">
        <b-select
          v-model="filter.emailType"
          placeholder="Email type"
          size="is-small"
          @input="loadData"
        >
          <option value="">Email type</option>
          <option value="loginCode">Login Code Request</option>
          <option value="downloadReadyEmail">Report ready to download</option>
          <option value="challengeJoinEmail">Challenge Join Request</option>
          <option value="challengeInviteEmail">Challenge Invite</option>
          <option value="teamChallengeInviteEmail">
            Team Challenge Invite
          </option>
          <option value="teamJoinEmail">Team Join Request</option>
          <option value="teamInviteEmail">Team Invite</option>
          <option value="requestToJoinEmail">Request to join challenge</option>
          <option value="registrationWelcomeEmail">New user welcome</option>
          <option value="registrationAdminWelcomeEmail">
            New user welcome (Admin)
          </option>
          <option value="friendEmail">Friend Request</option>
          <option value="friendInviteEmail">Friend Invite</option>
          <option value="programNearCapacityEmail">
            Program Near Capacity Alert
          </option>
          <option value="programAtCapacityEmail">
            Program At Capacity Alert
          </option>
          <option value="passwordResetEmail">Password Reset</option>
          <option value="companionUserWorkshopRegistrationEmail">
            Workshop Registration Confirmation
          </option>
          <option value="challengeEndingSoonEmail">
            Challenge Ending Soon
          </option>
          <option value="challengeEndingSoonAdminEmail">
            Challenge Ending Soon (Admin)
          </option>
          <option value="challengeResultsEmail">Challenge Results</option>
          <option value="milestonePassedEmail">Milestone Passed</option>
          <option value="badgeIssuedEmail">Badge Issued</option>
        </b-select>
      </div>
      <div class="column">
        <b-select
          v-model="filter.deliveryStatus"
          placeholder="Queue Status"
          size="is-small"
          @input="loadData"
        >
          <option value="">Queue Status</option>
          <option value="Queued">Queued</option>
          <option value="Success">Success</option>
          <option value="Failed">Failed</option>
        </b-select>
      </div>
    </section>
    <b-table
      :data="data"
      :loading="loading"
      paginated
      pagination-simple
      backend-pagination
      pagination-size="is-small"
      :total="total"
      :per-page="perPage"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @click="onItemClick"
    >
      <b-table-column field="createdAt" label="Queued At">
        <template v-slot="props">
          {{
            new Date(props.row.createdAt).toLocaleDateString() +
              " " +
              new Date(props.row.createdAt).toLocaleTimeString()
          }}
        </template>
      </b-table-column>
      <b-table-column v-slot="props" field="programName" label="Program Name">
        {{ props.row.programName }}
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="userFullName"
        label="Recipient Name"
      >
        {{ props.row.userFullName }}
      </b-table-column>
      <b-table-column v-slot="props" field="email" label="Email">
        {{ props.row.email }}
      </b-table-column>
      <b-table-column v-slot="props" field="emailType" label="Email Type">
        {{ props.row.emailType }}
      </b-table-column>
      <b-table-column
        v-slot="props"
        field="deliveryStatus"
        label="Queue Status"
      >
        {{ props.row.deliveryStatus }}
      </b-table-column>
      <template #empty>
        <div class="has-text-centered">No Results</div>
      </template>
    </b-table>

    <b-modal v-model="modal.show">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <div>Queue Delivery Code: {{ modal.deliveryCode }}</div>
            <div>
              {{ modal.recipientName }} &lang;{{ modal.recipientEmail }}&rang;
            </div>
            <div>{{ modal.subject }}</div>
            <!-- eslint-disable-next-line -->
            <div v-html="modal.emailContent"></div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "EmailQueue",

  data() {
    return {
      data: [],
      autocompleteData: [],
      total: 100,
      loading: true,
      autocompleteLoading: false,
      page: 1,
      perPage: 10,
      filter: {
        email: null,
        emailType: null,
        deliveryStatus: null,
        programId: null
      },
      modal: {
        show: false,
        recipientName: null,
        recipientEmail: null,
        subject: null,
        emailContent: null,
        deliveryCode: null
      }
    };
  },

  async mounted() {
    await this.loadData();
  },

  methods: {
    ...mapActions("emailQueue", ["searchEmailQueue"]),
    ...mapActions("program", ["programAutocompleteSearch"]),
    onPageChange(page) {
      this.page = page;
      this.loadData();
    },
    onItemClick(row) {
      this.modal.recipientName = row.userFullName;
      this.modal.recipientEmail = row.email;
      this.modal.subject = row.subject;
      this.modal.emailContent = row.emailContent;
      this.modal.deliveryCode = row.deliveryCode;
      this.modal.show = true;
    },
    onFilter() {
      // put a 3-second delay to avoid overly hitting the endpoint.
      _.debounce(this.loadData, 1000)();
    },
    onselect(item) {
      if (item) {
        this.filter.programId = item.id;
      } else {
        this.filter.programId = null;
      }

      this.loadData();
    },
    loadData() {
      this.loading = true;

      try {
        this.searchEmailQueue({
          page: this.page,
          perPage: this.perPage,
          filter: this.filter
        })
          .then(response => {
            this.data = response.data.data.items;
            this.total = response.data.data.totalRows;
          })
          .catch(e => {
            this.$buefy.toast.open("Failed to load queue list.");

            console.error(e);
          });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    onTyping(value) {
      _.debounce(this.autocompleteSearch, 1000)(value);
    },
    autocompleteSearch(value) {
      this.autocompleteLoading = true;

      try {
        this.programAutocompleteSearch(value)
          .then(response => {
            this.autocompleteData = response.data.data;
          })
          .catch(e => {
            this.$buefy.toast.open("Failed to load program search results.");

            console.error(e);
          });
      } catch (e) {
        console.error(e);
      } finally {
        this.autocompleteLoading = false;
      }
    }
  }
};
</script>
